<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Remittance') }}</h3>
                <span class="fz-16 fw-400">Fill out the form to resubmit remittance</span>
            </div>

            <step-container
                :current_step="4"
                :step_list="stepList"
            ></step-container>
        </div>

        <b-container fluid class="mt-0 pb-5">
        
            <b-row>
                <b-col cols="12" md="8" class="mx-auto">
                    <div id="body-container" v-if="remittance">
                        <div class="p-0 pb-3 text-center">
                            <img :src="`${publicPath}/img/gep/withdrawal-icon.svg`" style="background-color: #EDF8F1;border-radius: 20px;">
                            <h5 class="my-3">Resubmit Remittance</h5>
                            <hr/>
                            <div class="d-flex mb-3">
                                <div>Payment Methods</div>
                                <div class="ml-auto fw-700">{{ remittance.paymentMode }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Amount</div>
                                <div class="ml-auto fw-700">{{ remittance.paymentCcy }} {{ (remittance.fixedModel == 1)?getAmount(remittance.paymentAmount):getAmount(remittance.payeeAmount) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Payment Fee</div>
                                <div class="ml-auto fw-700">USD {{ getAmount(remittance.paymentFee) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Payment Fee Currency</div>
                                <div class="ml-auto fw-700">{{ remittance.paymentFeeCcy }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Partner Account Name</div>
                                <div class="ml-auto fw-700">{{ remittance.accountName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Partner Currency</div>
                                <div class="ml-auto fw-700">{{ remittance.payeeCcy }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Partner Account Number</div>
                                <div class="ml-auto fw-700">{{ remittance.cardNo }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Payment Type</div>
                                <div class="ml-auto fw-700">{{ getType(remittance.fixedModel) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Purpose of Payment</div>
                                <div class="ml-auto fw-700">{{ getPurpose(remittance.paymentPurpose) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Payment Reference</div>
                                <div class="ml-auto fw-700">{{ remittance.paymentReference }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank charges to be borne</div>
                                <div class="ml-auto fw-700">{{ getCostBorne(remittance.costBorne) }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Proof of Payment</div>
                                <div class="ml-auto fw-700">
                                    <a class="link" :download="'voucher.'+filetypePaymentMaterial" :href="encodePaymentMaterial" target="_blank">Download Voucher</a>
                                </div>
                            </div>
                        </div>
                        <div class="p-0 pb-5 text-center">
                            <div class="d-flex mb-3">
                                <h5>Partner Info</h5>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Name</div>
                                <div class="ml-auto fw-700">{{ add_partner.name }}</div>
                            </div>

                            <div class="d-flex mb-3">
                                <div>Name - English</div>
                                <div class="ml-auto fw-700">{{ add_partner.enName }}</div>
                            </div>

                            <div class="d-flex mb-3">
                                <div>Phone Number</div>
                                <div class="ml-auto fw-700">{{ add_partner.phoneNum }}</div>
                            </div>

                            <div class="d-flex mb-3">
                                <div>Country</div>
                                <div class="ml-auto fw-700">{{ add_partner.countryName }}</div>
                            </div>

                            <div class="d-flex mb-3">
                                <div>Province</div>
                                <div class="ml-auto fw-700">{{ add_partner.province }}</div>
                            </div>

                            <div class="d-flex mb-3">
                                <div>City</div>
                                <div class="ml-auto fw-700">{{ add_partner.city }}</div>
                            </div>

                            <div class="d-flex mb-3">
                                <div>Zip Code</div>
                                <div class="ml-auto fw-700">{{ add_partner.zipCode }}</div>
                            </div>

                            <div class="d-flex mb-3">
                                <div>Address</div>
                                <div class="ml-auto fw-700">{{ add_partner.address }}</div>
                            </div>
                            <hr>
                            <div class="d-flex mb-3">
                                <h5>Bank Info</h5>
                            </div>

                            <div class="d-flex mb-3">
                                <div>Account Type</div>
                                <div class="ml-auto fw-700">{{ bank_info.accType==1?'Business':'Individual' }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Account Currency</div>
                                <div class="ml-auto fw-700">{{ bank_info.accountCcy }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Account Name</div>
                                <div class="ml-auto fw-700">{{ bank_info.accountName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Card Number</div>
                                <div class="ml-auto fw-700">{{ bank_info.cardNo }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Payment Channel Type</div>
                                <div class="ml-auto fw-700">{{ bank_info.paymentChannelType }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank Name</div>
                                <div class="ml-auto fw-700">{{ bank_info.bankName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank Branch Name</div>
                                <div class="ml-auto fw-700">{{ bank_info.bankBranchName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank Country</div>
                                <div class="ml-auto fw-700">{{ bank_info.countryName }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Swift Code</div>
                                <div class="ml-auto fw-700">{{ bank_info.swiftCode }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Partner Address</div>
                                <div class="ml-auto fw-700">{{ add_partner.address }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank Address</div>
                                <div class="ml-auto fw-700">{{ bank_info.bankAddress }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Bank code</div>
                                <div class="ml-auto fw-700">{{ bank_info.clearingCode }}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div>Card Type</div>
                                <div class="ml-auto fw-700">{{ getCardType(bank_info.cardType) }}</div>
                            </div>
                            <hr/>
                            <div class="d-flex mb-0">
                                <button @click="$router.go(-1);" class="btn btn-previous d-block mr-auto">{{ $t('Previous') }}</button>
                                <button @click="$bvModal.show('modal-payment-password');" class="btn btn-primary d-block">{{ $t('Submit') }}</button>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        
      </b-container>

    
      <b-modal id="modal-payment-password" hide-footer hide-title>
        <PaymentPassword @on-submit="validatePin"></PaymentPassword>
      </b-modal>

      <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import stepContainer from "@/components/CardManagement/stepContainer";
    import PaymentPassword from "@/components/PaymentPassword";
    import Global from '@/services/Global';
    import DB from '@/services/DB';
    import Withdrawal from "@/services/Withdrawal";
    import Common from "@/services/Common";
    import CreateAccount from '@/services/CreateAccount';

  
    export default {
        name: 'resubmit-remittance-summary',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                remittance: null,
                bank_info: null,
                add_partner:null,
                maxSize:4,
                paymentMaterial:'',
                encodePaymentMaterial:'',
                filetypePaymentMaterial:'',
                fixedModelList:{
                    1:"Foreign Exchange Account",
                    2:"Receiving Account"
                },
                paymentPurposeOpt:{
                    1:"current settlement",
                    2:"loan",
                    3:"travel expenses",
                    4:"living expenses",
                    5:"investment funds",
                    6:"office expenses",
                    7:"engineering funds",
                    8:"labor costs/salaries",
                    9:"tuition fees",
                    10:"others"
                },
                costBorneOpt:{
                    "OUR":"OUR (sender pays all charges)",
                    "SHA":"SHA (shared charges)"
                },
                paymentChannelTypeOpt:{
                    "SWIFT":"SWIFT",
                    "LOCAL":"LOCAL"
                },
                stepList:["Update Partner Info", "Update Bank Info", "Update Remittance", "Summary"],
            }
        },
        components: {
            LoaderComponent,
            stepContainer,
            PaymentPassword
        },
        methods:{
            validatePin(pin){
                let self = this;
                this.isLoading = true;
                Common.validate_payment_password({
                    "securitycode":pin.join(""),
                }).then(response=>{
                    if(response.status==200){
                        this.$bvModal.hide('modal-payment-password');
                        this.updatePartner();
                    }
                }).catch(err => {
                    self.isLoading = false;
                    this.checkError(err);
                });
            },
            getCardType(type){
                if(type == 10){
                    return "DEPOSIT";
                }
                else if(type == 11){
                    return "SAVING";
                }
                else{
                    return "CHECKING";
                }
            },
            getCostBorne(type){
                return this.costBorneOpt[type];
            },
            getPurpose(type){
                return this.paymentPurposeOpt[parseInt(type)];
            },
            getAmount(amount){
                return Global.addCommas(amount);
            },
            getMessage: function (key) {
                return this.$t(key)
            },
            getType(type){
                return this.fixedModelList[parseInt(type)];
            },
            updatePartner(){
                let self = this;
                this.isLoading = true;

                Withdrawal.updatePartner({
                    partnerBankId:self.remittance.partnerBankId,
                    "partner":{
                        "countryCode":self.add_partner.countryCodeIso3,
                        "name":self.add_partner.name,
                        "enName":self.add_partner.enName,
                        "address":self.add_partner.address,
                        "userNo": self.bank_info.userNo
                    },
                    "partnerBank":{
                        "accType":self.bank_info.accType,
                        "accountCcy":self.bank_info.accountCcy,
                        "accountName":self.bank_info.accountName,
                        "cardNo":self.bank_info.cardNo,
                        "paymentChannelType":self.bank_info.paymentChannelType,
                        "bankName":self.bank_info.bankName,
                        "bankBranchName":self.bank_info.bankBranchName,
                        "countryCode":self.bank_info.countryCodeIso3,
                        "swiftCode":self.bank_info.swiftCode,
                        "payeeAddress":self.add_partner.address,
                        "bankAddress":self.bank_info.bankAddress,
                        "clearingCode":self.bank_info.clearingCode,
                        "cardType":self.bank_info.cardType,
                        "phoneNum":self.add_partner.phoneNum,
                        "province":self.add_partner.province,
                        "city":self.add_partner.city,
                        "zipCode":self.add_partner.zipCode
                    }
                }).then((response)=>{
                    if (response.status == 200) {
                        let data = response.data.data;
                        self.uploadProof();
                    }
                })
                .catch((err) => {
                    console.log(err);
                    self.checkError(err);
                });
            },
            uploadProof(){
                let self = this;
                
                if(self.encodePaymentMaterial.indexOf("http://")!=-1 || self.encodePaymentMaterial.indexOf("https://")!=-1){
                    this.paymentMaterial = self.remittance.paymentMaterial;       
                }

                if(this.paymentMaterial=='' || this.paymentMaterial==null){
                    CreateAccount.uploadFile({
                        "accountId":self.remittance.accountId,
                        "userNo":""+self.remittance.userNo,
                        "fileUpload":[
                            {
                                "type":23,
                                "maxSize":self.maxSize*1024*1024,
                                "file":self.encodePaymentMaterial
                            }
                        ]
                    }).then(response => {
                        const data = response.data.data;
                        let fileList = data["file"];
                        for(let i=0;i<fileList.length;i++){
                            if(fileList[i].type==23){
                                self.paymentMaterial = fileList[i].fileId;
                            }
                        }
                        self.doSubmit();
                    }).catch(err => {
                        self.checkError(err);
                    });
                }
                else{
                    self.doSubmit();
                }
            },
            doSubmit(){
                let self = this;
                Withdrawal.submitRemittance({
                    remittance_id:parseInt(this.$route.query.id),
                    userNo:this.remittance.userNo,
                    partnerBankId:this.remittance.partnerBankId,
                    paymentMode:this.remittance.paymentMode,
                    paymentAmount:this.remittance.paymentAmount,
                    payeeAmount:this.remittance.payeeAmount,
                    fixedModel:parseInt(this.remittance.fixedModel),
                    paymentCcy:this.remittance.paymentCcy,
                    paymentPurpose:parseInt(this.remittance.paymentPurpose),
                    paymentReference:this.remittance.paymentReference,
                    costBorne:this.remittance.costBorne,
                    paymentFeeCcy:this.remittance.paymentFeeCcy,
                    paymentMaterial:this.paymentMaterial
                }).then((response)=>{
                    if (response.status == 200) {
                        self.isLoading = false;
                        let data = response.data.data;
                        localStorage.removeItem("update_remittance");
                        localStorage.removeItem('update_partner');
                        localStorage.removeItem('update_bank_info');

                        DB.delete("paymentMaterial_filetype").then(data => {
                            self.filetypePaymentMaterial = filetype;
                        });
                        DB.delete("paymentMaterial").then(data => {
                            self.$swal({
                                icon: 'success',
                                title: self.getMessage('Success'),
                                showConfirmButton: true,
                            }).then((result) => {
                                self.$router.push({ 
                                    path: '/withdrawal', 
                                });
                            }); 
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    self.checkError(err);
                });
            },
            checkError(err){
                this.isLoading = false;
                const response = err.response;  
                let self = this;
                
                if(response.status == 400 || response.status == 500){
                    try{
                        response.data.message = JSON.parse(response.data.message);
                    }
                    catch(e){
                        console.log("");
                    }

                    if(typeof response.data.message === 'string'){
                        this.$swal({
                            icon: 'info',
                            html:response.data.message,
                            showConfirmButton: true,
                            confirmButtonText: self.getMessage('OK')
                        });
                    }
                    else{
                        if(response.data.message['errorMsg']){
                            this.$swal({
                                icon: 'info',
                                html:response.data.message['errorMsg'],
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                        else{
                            let ret = [];
                            Object.keys(response.data.message).forEach((key) => {
                                if(typeof response.data.message === 'string'){
                                    ret.push(response.data.message[key][0]);
                                }
                                else{
                                    ret.push(response.data.message[key][0]['message']);
                                }
                            });

                            this.$swal({
                                icon: 'info',
                                html:ret.join("<br>"),
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                    }
                }      
                else if(response.status == 401 && response.data.name == "Unauthorized"){
                        localStorage.removeItem("token");
                        localStorage.removeItem("member");
                        localStorage.removeItem("isFirstTime");
                        this.$router.push({ 
                            path: '/login', 
                        });
                }
                else{
                    if(localStorage.getItem("token")){
                        var msg = (response.data)?response.data.message:err.message;
                        this.$notify({
                            type: 'warn',
                            text: msg
                        })
                    }
                }
            }
        },
        mounted(){
            let self = this;
            const savedremittance = JSON.parse(localStorage.getItem('update_remittance'));
            this.remittance = savedremittance;

            const savedadd_partner = JSON.parse(localStorage.getItem('update_partner'));
            const savedbank_info = JSON.parse(localStorage.getItem('update_bank_info'));
            this.add_partner = savedadd_partner;
            this.bank_info = savedbank_info;

            DB.get("paymentMaterial_filetype_update").then(filetype => {
                self.filetypePaymentMaterial = filetype;
            });

            DB.get("paymentMaterial_update").then(data => {
                if(data){
                    self.encodePaymentMaterial = data;
                }
            });
        }
    };
  </script>

<style scoped>
a.link{
    color: #6153d7 !important;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
}
ul li{
    list-style: disc;
}
.point .number{
    background-color: rgba(103, 163, 83, 1);
    border-radius: 50%;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    padding: 3px;
    font-weight: 500;
    color: #fff;
}
.account-type:hover{
    background: linear-gradient(90deg, #00AEEF 0%, #0972D3 100%) !important;
}
.block-item{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}
hr{
    border-style: dashed;
}
</style>